import React from "react";
import styles from "./shot-table.module.scss";
import { ContainerPanel } from "@src/components/organisms/container-panel/container-panel";
import { SubHeader } from "@src/components/atoms/sub-header/sub-header";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { ContainerPane } from "@src/components/organisms/container-pane/container-pane";
import { TimezoneDate } from "@src/components/atoms/timezone-date/timezone-date";
import { useShotTableHook } from "./use-shot-table-hook";
import Spinner from "@src/components/atoms/spinner/spinner";

const cssClassName = "shot-table";

export const ShotTable = () => {
  const {
    texts,
    columns,
    rows,
    selectedRowIndex,
    setSelectedRowIndex,
    isLoading,
    isTimestampColumn,
  } = useShotTableHook();

  return (
    <ContainerPanel>
      <SubHeader>
        <SubTitle text={texts.title} />
      </SubHeader>
      <ContainerPane>
        {isLoading ? (
          <Spinner />
        ) : !columns.length || !rows.length ? (
          <div className={styles[`${cssClassName}__empty`]}>
            {texts.noDataAvailable}
          </div>
        ) : (
          <div className={styles[`${cssClassName}__table-wrapper`]}>
            <table className={styles[`${cssClassName}__table`]}>
              <thead className={styles[`${cssClassName}__thead`]}>
                <tr>
                  {columns.map((column, columnIndex) => (
                    <th
                      key={`${column.name}-${columnIndex}`}
                      className={styles[`${cssClassName}__th`]}
                    >
                      <div
                        className={styles[`${cssClassName}__header-content`]}
                      >
                        <div className={styles[`${cssClassName}__header-text`]}>
                          <span>{column.name}</span>
                          <span
                            className={styles[`${cssClassName}__header-unit`]}
                          >
                            {column.unit}
                          </span>
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {rows.map((row, rowIndex) => (
                  <tr
                    key={`row-${rowIndex}`}
                    className={`${styles[`${cssClassName}__tr`]} ${
                      selectedRowIndex === rowIndex
                        ? styles[`${cssClassName}__tr--selected`]
                        : ""
                    }`}
                    onClick={() => setSelectedRowIndex(rowIndex)}
                  >
                    {columns.map((column, columnIndex) => {
                      const value = row[columnIndex];

                      return (
                        <td
                          key={`cell-${rowIndex}-${columnIndex}`}
                          className={styles[`${cssClassName}__td`]}
                        >
                          {value !== null &&
                            value !== undefined &&
                            (isTimestampColumn(value) ? (
                              <TimezoneDate date={String(value)} />
                            ) : (
                              value
                            ))}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </ContainerPane>
    </ContainerPanel>
  );
};
